export const allEqual = <T>(arrOne: T[], arrTwo: T[]) => {
  if (arrOne.length !== arrTwo.length) {
    return false;
  }

  return arrOne.every((v) => arrTwo.includes(v));
};
